import React from 'react';
import {Box, IconButton, Tooltip} from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';

// Переключатель темы: «таблетка» с ползунком и иконками солнца/луны (в свёрнутой панели — круглая кнопка с вращающейся иконкой).
const ThemeToggle = ({mode, onToggle, compact}) => {
    const dark = mode === 'dark';
    const label = dark ? 'Включить светлую тему' : 'Включить тёмную тему';

    if (compact) {
        return (
            <Tooltip title={label} placement="right">
                <IconButton size="small" onClick={onToggle} aria-label={label}>
                    <Box key={mode} sx={{display: 'flex', animation: 'themeIconSpin .5s cubic-bezier(0.4, 0, 0.2, 1)',
                        '@keyframes themeIconSpin': {from: {transform: 'rotate(-120deg) scale(0.4)', opacity: 0}, to: {transform: 'none', opacity: 1}}}}>
                        {dark ? <DarkModeIcon fontSize="small"/> : <LightModeIcon fontSize="small" sx={{color: '#f59e0b'}}/>}
                    </Box>
                </IconButton>
            </Tooltip>
        );
    }

    return (
        <Tooltip title={label} placement="top">
            <Box
                role="switch"
                aria-checked={dark}
                aria-label={label}
                tabIndex={0}
                onClick={onToggle}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onToggle(e); } }}
                sx={{
                    position: 'relative', width: 56, height: 28, borderRadius: 14, cursor: 'pointer', flexShrink: 0,
                    background: dark ? 'linear-gradient(135deg, #1b2440 0%, #2d3a67 100%)' : 'linear-gradient(135deg, #8ecbff 0%, #cfe9ff 100%)',
                    boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.35)',
                    transition: 'background .4s ease',
                    outline: 'none',
                    '&:focus-visible': {boxShadow: (t) => `0 0 0 2px ${t.palette.primary.main}`},
                }}
            >
                <Box sx={{
                    position: 'absolute', top: 3, left: 3, width: 22, height: 22, borderRadius: '50%',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    transform: dark ? 'translateX(28px)' : 'translateX(0)',
                    background: dark ? '#e8ecff' : '#ffd54a',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.35)',
                    transition: 'transform .4s cubic-bezier(0.4, 0, 0.2, 1), background .4s ease',
                }}>
                    <Box key={mode} sx={{display: 'flex', animation: 'themeIconSpin .5s cubic-bezier(0.4, 0, 0.2, 1)',
                        '@keyframes themeIconSpin': {from: {transform: 'rotate(-120deg) scale(0.4)', opacity: 0}, to: {transform: 'none', opacity: 1}}}}>
                        {dark ? <DarkModeIcon sx={{fontSize: 15, color: '#2d3a67'}}/> : <LightModeIcon sx={{fontSize: 15, color: '#b26a00'}}/>}
                    </Box>
                </Box>
            </Box>
        </Tooltip>
    );
};

export default ThemeToggle;
